<template>
  <header class="header header--mobile" :class="{ 'header--ios': view.isIOS }">
    <div class="header__inner">
      <div class="header__title-wrapper">
        <h1 class="header__title">
          {{ title }}
        </h1>
      </div>
      <DocsSortButtonMobile v-if="hasDocSort" />
      <StartFreeTrialButton
        v-if="view.showCtaButtonOnMobile"
        class="header__trial-btn"
        :view="view"
      />
      <slot name="actions">
        <HeaderUserMenu :view="view" />
      </slot>
      <div v-if="subtitle" class="header__subtitle-wrapper">
        <h1 class="header__subtitle">
          {{ subtitle }}
        </h1>
      </div>
    </div>
    <!-- FirstGuidePopup can appear on any page after onboarding.
         As a popup, it will Teleport to #appRoot. -->
    <FirstGuidePopup />
    <slot></slot>
  </header>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from './UserMenu.vue'
import FirstGuidePopup from '@/app/components/onboarding/FirstGuidePopup.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'
import DocsSortButtonMobile from '@/app/components/listing/DocsSortButton.mobile.vue'

withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    hasDocSort?: boolean
  }>(),
  {
    hasDocSort: false,
  },
)

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style>
/**
 * The styles for this component are defined in `@/assets.app/css/components/_header.scss`
 */
</style>
